module.exports = __webpack_public_path__ + "img/henrique.ba2c8bda.jpg";